import React, { Component, Context } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { IEventActionDispatches, mapEventDispatchToProps } from "../../redux/actions/event";
import { IEventState, mapEventStateToProps } from "../../redux/reducers/event";
import { IEvent } from "../../laco-common/base/models/event";
import { getDateStringInTimezone } from "../../laco-common/base/utils";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import { displayDateTime2 } from "../../laco-common/helpers";
import "./HomeEvents.scss";

class HomeEvents extends Component<IEventActionDispatches & IEventState & RouteComponentProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {};

	componentDidMount() {
		this.props.loadGroups();
		this.props.loadHomePageEvents();
	}

	render() {
		const events: IEvent[] = this.props.homeEvents || [];
		return (
			<div
				className={clsx(
					"d-flex flex-column flex-md-row",
					this.context.settings.isDesktopRes ? "container" : "container-fluid",
					events.length >= 4 && "justify-content-between",
					events.length < 4 && "justify-content-around"
				)}
			>
				{events.map((event: IEvent) => {
					return (
						<div
							className="event-preview text-white d-flex flex-column justify-content-between"
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								this.props.history.push(`/events/${event.id}`);
							}}
							key={event.id}
						>
							<div className="position-relative">
								<h4>{displayDateTime2(event.eventDate as number)}</h4>
								<span
									className="event-color"
									style={{ backgroundColor: (this.props.groupsColorsMap || {})[event.group_id] }}
								></span>
								{event.title}
							</div>
							<NavLink
								to={`/events/${event.eventDate}`}
								onClick={(e) => {
									e.stopPropagation();
								}}
							>
								View Calendar
							</NavLink>
						</div>
					);
				})}
			</div>
		);
	}
}

export default connect<IEventState, IEventActionDispatches>(
	mapEventStateToProps,
	mapEventDispatchToProps
)(withRouter(HomeEvents));
